/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResourceRoleDto } from '../../models/resource-role-dto';

export interface GetResourceRoles1$Params {
}

export function getResourceRoles1(http: HttpClient, rootUrl: string, params?: GetResourceRoles1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResourceRoleDto>>> {
  const rb = new RequestBuilder(rootUrl, getResourceRoles1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResourceRoleDto>>;
    })
  );
}

getResourceRoles1.PATH = '/case-resources/user/roles';
